import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { AppBar, Tabs, Tab, Box, Button, Grid } from '@material-ui/core/';
import MyBots from './MyBots';
import AllBots from './AllBots';
import Search from '../../../components/Search/Search';
import CustomizeView from '../../../components/DataTable/CustomizeView/CustomizeView';
import Filters from '../../../components/DataTable/Filters/Filters';
import IpaasService from '../../../services/IpaasService/IpaasService';
import BotService from '../../../services/BotService/BotService';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { alertState, rolePermission } from '../../../recoil-store/recoil-state';

const TabStyle = withStyles((theme) => ({
    root: {
        fontSize: 12,
        fontWeight: 700,
        textTransform: 'none',
        '&:hover': {
            color: 'var(--gravel) !important',
            opacity: 1
        },
        '&$selected': {
            color: 'var(--black-pearl)'
        }
    },
    selected: {}
}))((props) => <Tab {...props} />)

const useStyles = makeStyles(theme => ({
    customTabIndicator: {
        height: 3,
        backgroundColor: 'var(--black-pearl)',
        width: '88px!important',
        marginLeft: '35px'
    }
}));

function TabPanel({ children, value, index, ...other }) {
    return (
        <div hidden={value !== index} {...other} className='hei-100'>
            {value === index && (<Box className='hei-100'>{children}</Box>)}
        </div>
    );
}

/**
 * @Description This function lets you return component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function FullWidthTabs(props) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [customColumn, setCustomColumn] = useState([]);
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState({ open: false, bot: {} });
    const [searchKeyData, setSearchKeyData] = useState([]);
    const [openFilters, setOpenFilters] = useState(false);
    const classes = useStyles();
    const label = 'CONTENT.PUBLISH-APPROVE.';
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);

    useEffect(() => {
        fetchData(0).then(r => r);
    }, []);

    function handleOpen(open, setState) {
        setState(!open);
    }

    const fetchData = useCallback(async (val) => {
        setLoading(true);
        let response;
        if (props.type === 'bot') {
            response = await BotService.getApprovements(val === 0 ? 'PENDING,CANCELED,APPROVED,REJECTED&all=false' : 'PENDING&all=true');
        } else {
            response = await IpaasService.getApprovements(val === 0 ? 'PENDING,CANCELED,APPROVED,REJECTED&all=false' : 'PENDING&all=true');
        }
        if (response) {
            if (response?.status) {
                setData(response.data);
                setSearchData(response.data);
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t(response?.message), severity: 'error' }));
        }
        setLoading(false);
    }, [loading, BotService, IpaasService, setData, setSearchData])

    const handleChange = (event, newValue) => {
        setValue(newValue);
        fetchData(newValue).then(r => r);
    };

    return (
        <div id="credential-container" className='data-body-container'>
            <Search data={data} setSearchData={setSearchData} searchKey={searchKeyData} xs={11} sm={11} md={11} lg={4}
                xl={4} spacing={2}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
                </Grid>
            </Search>
            <AppBar id="credential-appbar" position="static" color="default">
                <Tabs id="credential-tabs" value={value} onChange={handleChange}
                    classes={{ indicator: classes.customTabIndicator }}>
                    <TabStyle label={t(label + 'MYBOTS')} />
                    {permissions?.data.includes('INTEGRATIONMARKET_PUBLISHAPPROVE') &&
                        <TabStyle label={t(label + 'ALLBOTS')} />
                    }
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <MyBots fetchData={fetchData} setOpen={setOpen} customColumn={customColumn} loading={loading}
                    type={props.type}
                    setSearchKeyData={setSearchKeyData} searchData={searchData} setCustomColumn={setCustomColumn}
                    open={open} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <AllBots fetchData={fetchData} setOpen={setOpen} customColumn={customColumn} loading={loading}
                    type={props.type}
                    setSearchKeyData={setSearchKeyData} searchData={searchData} setCustomColumn={setCustomColumn}
                    open={open} />
            </TabPanel>
            {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                setCustomColumn={setCustomColumn} />}
            {openFilters &&
                <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn} />}
        </div>
    );
}

export default FullWidthTabs;
